import React from "react";
import Nav from "../Nav/NavBar";
import SideDrawer from "../SideDrawer/SideDrawer";
import Backdrop from "../Backdrop/Backdrop";

class Layout extends React.Component {
  state = {
    sideDrawerOpen: false
  };

  drawerToggleClickHandler = () => {
    this.setState(prevState => {
      return { sideDrawerOpen: !prevState.sideDrawerOpen };
    });
  };

  backDropClickHandler = () => {
    this.setState({ sideDrawerOpen: false });
  };
  render() {
    let backdrop;
    if (this.state.sideDrawerOpen) {
      backdrop = <Backdrop click={this.backDropClickHandler} />;
    }

    return (
      <div style={{ height: "100%" }}>
        <Nav drawerClickHandler={this.drawerToggleClickHandler} />
        <SideDrawer
          show={this.state.sideDrawerOpen}
          close={this.backDropClickHandler}
        />
        {backdrop}
        <div style={styles.placeChild}>{this.props.children}</div>
      </div>
    );
  }
}

const styles = {
  placeChild: {
    marginTop: "64px"
    // justifyContent:"center",
    // alignItems:"center"
  }
};

export default Layout;
